import React, { useContext } from "react";
import BasicModal from "../../../../Components/Modals/BasicModal";
import Btn from "../../../../Components/Buttons/Btn";
import { MdShare } from "react-icons/md";

const ApproveModal = ({ showApprove, setShowApprove, handleApprove }) => {
  if (showApprove) {
    return (
      <BasicModal
        showModal={showApprove}
        setShowModal={setShowApprove}
        header="Approve Expense"
      >
        <div className="m-auto p-5">
          <h2 className="text-center text-primary text-xl font-bold  mb-6">
            Are you sure you want to Approve this Expense?
          </h2>
          <div className="flex justify-between items-center">
            <Btn
              outline={true}
              btn="border"
              onClick={() => setShowApprove(false)}
            >
              <p className="">Cancel</p>
            </Btn>
            <Btn outline={true} btn="border" onClick={handleApprove}>
              <div className="flex justify-between items-center gap-x-2">
                <MdShare className="text-green" />
                <p className="">Confirm</p>
              </div>
            </Btn>
          </div>
        </div>
      </BasicModal>
    );
  }
};

export default ApproveModal;
